export default __webpack_public_path__ + "7d54df9193265d65aa52d849a1860c25.png";